import * as React from "react";
import { Box, Typography, Stack } from "@mui/material";

export const NotFoundPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f5f5f5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Stack
        spacing={3}
        alignItems="center"
        sx={{
          bgcolor: "#fff",
          borderRadius: 2,
          boxShadow: "0 12px 32px rgba(0,0,0,0.07)",
          border: "1px solid",
          borderColor: "divider",
          maxWidth: 400,
          width: "100%",
          textAlign: "center",
          p: 4,
        }}
      >
        <Typography variant="h4" fontWeight={600}>
          404 😬
        </Typography>

        <Typography variant="body1" color="text.secondary">
          Cette page n'existe pas.
          <br />
          (Ou alors elle s'est cachée derrière un conteneur de déchets dangereux, et on n'a pas l'EPI pour aller la chercher 😅)
        </Typography>
      </Stack>
    </Box>
  );
};
